import { render, staticRenderFns } from "./ActivityImageWithTextContainer.vue?vue&type=template&id=3e5d0af4&scoped=true"
import script from "./ActivityImageWithTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityImageWithTextContainer.vue?vue&type=script&lang=ts"
import style0 from "./ActivityImageWithTextContainer.vue?vue&type=style&index=0&id=3e5d0af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d0af4",
  null
  
)

/* custom blocks */
import block0 from "./ActivityImageWithTextContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports